import { render, staticRenderFns } from "./SimpleAnswer.vue?vue&type=template&id=2180f46e&scoped=true"
import script from "./SimpleAnswer.ts?vue&type=script&lang=ts&external"
export * from "./SimpleAnswer.ts?vue&type=script&lang=ts&external"
import style0 from "./SimpleAnswer.scss?vue&type=style&index=0&id=2180f46e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2180f46e",
  null
  
)

export default component.exports